import axios from "./config.service";

export interface Asset {
  codeAsset: string;
  nameAsset: string;
  areaCode: string;
  increasingDate: Date;
  numOfUpdate: number;
  updatedDate: Date;
}

export class AssetService {
  static async getList(assetCode: string) {
    try {
      const res = await axios.get<{ data: Asset[]; statusCode: number }>("/viagsasset/get-list", {
        params: { keyword: assetCode },
      });
      if (res.data.statusCode !== 200) return;
      return res.data.data;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async updateNumberUpdate(assetCode: string) {
    try {
      const res = await axios.post<{ statusCode: number }>("/viagsasset/increasing-num-update", null, {
        params: { assetCode: assetCode },
      });
      if (res.data.statusCode !== 200) return;
      return true;
    } catch (error: any) {
      console.log(error);
    }
  }

  static async addAsset(fields: any) {
    try {
      const res = await axios.post("/viagsasset/add", fields);
      if (res.data.statusCode !== 200) return res.data;
      return res.data;
    } catch (error: any) {
      console.log(error);
    }
  }
}
